import { useTranslation } from 'react-i18next';
import styles from '../styles.module.css';

export const Title = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.bodyTextContainerTitle}>
      <h1 className={styles.title}>
        {t('chatsocket.title.launch_campaign')}
        <br />
        <span className={styles.highlight}>{t('chatsocket.title.in_minutes')}</span>
      </h1>
    </div>
  );
};